import { RoutingConfig } from '@spartacus/core'
import { Routes } from '@angular/router'
import { PageLayoutComponent } from '@spartacus/storefront'
import { CheckoutPagesGuard } from '../guards/checkout-pages.guard'
import { MbCdcAuthGuard } from '../../auth/guards/mb-cdc-auth.guard'
import { CheckoutReviewPageGuard } from '../guards/checkout-review-page.guard'
import { OrderDetailsGuard } from '../guards/order-details.guard'

export const mbCheckoutRoutingConfig: RoutingConfig = {
  routing: {
    routes: {
      checkoutQuoteInfo: { paths: ['checkout/quote-info'] },
      checkoutContactDetails: { paths: ['checkout/contact-details'] },
      checkoutShippingAddress: { paths: ['checkout/shipping-address'] },
      checkoutBillingInfo: { paths: ['checkout/billing-address'] },
      checkoutReview: { paths: ['checkout/review'] },
      checkoutPaymentProviderPage: { paths: ['checkout/payment'] },
      checkoutConfirmation: { paths: ['checkout/confirmation/:orderCode'], paramsMapping: { orderCode: 'code' } },
    },
  },
}

export const mbCheckoutRoutes: Routes = [
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutQuoteInfo' }
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutContactDetails' }
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutShippingAddress' }
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutBillingInfo' }
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard, CheckoutReviewPageGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutReview' }
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutPaymentProviderPage' }
  },
  {
    path: null as any,
    canActivate: [MbCdcAuthGuard, CheckoutPagesGuard, OrderDetailsGuard],
    component: PageLayoutComponent,
    data: { cxRoute: 'checkoutConfirmation' }
  },
]
